import {PersonLogin} from '../person/person-login';
import {DocumentOption} from './document-option';

export class DocumentGenerationInput {

  user!: PersonLogin;
  entityId!: string;
  revision!: number;
  options!: DocumentOption[];

}
